import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '@Components/not-found/not-found.component';
import { PostLoginDataRestoreResolver } from './Resolvers/PostLoginRestoreResolver.resolver';
import { LoginCallbackResolver } from './Resolvers/LoginCallbackResolver.resolver';
import { legacyUrlGuard } from '@Guards/legacy-url.guard';
import { ensureCodesrGuard } from '@Guards/ensure-codesr.guard';
import { LoginRequiredComponent } from '@Components/login-required/login-required.component';
import { authGuard } from '@Guards/auth.guard';
import { rewardsSystemHealtyGuard } from '@Guards/rewards-system-healty.guard';
import { E_OFFER_GATEWAY_TYPE } from '@Interfaces/enums';


/* istanbul ignore next */
const routes: Routes = [
  {
    path: '',
    resolve: {
      navigationState: LoginCallbackResolver
    },
    canActivate:[legacyUrlGuard],
    loadChildren: () =>
      import('./Modules/buy-ticketless/buy-ticketless.module').then(
        (m) => m.BuyTicketlessModule
      ),
  },
  {
    path: 'buyTicketless',
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    canActivate: [ensureCodesrGuard],
    loadChildren: () =>
      import('./Modules/buy-ticketless/buy-ticketless.module').then(
        (m) => m.BuyTicketlessModule
      ),
  },
  {
    path: 'buyTicketless/:codesr', //:codesr = codice estero esadecimale identificativo del museo
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    canActivate: [ensureCodesrGuard],
    loadChildren: () =>
      import('./Modules/buy-ticketless/buy-ticketless.module').then(
        (m) => m.BuyTicketlessModule
      ),
  },
  {
    path: 'buyTicketless/:codesr/:idofferta', //:codesr = codice estero esadecimale identificativo del museo
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    canActivate: [ensureCodesrGuard],
    loadChildren: () =>
      import('./Modules/buy-ticketless/buy-ticketless.module').then(
        (m) => m.BuyTicketlessModule
      ),
  },
  {
    path: ':prefix/buyTicketless/:codesr', //:codesr = codice estero esadecimale identificativo del museo
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    canActivate: [ensureCodesrGuard],
    loadChildren: () =>
      import('./Modules/buy-ticketless/buy-ticketless.module').then(
        (m) => m.BuyTicketlessModule
      ),
  },
  {
    path: ':prefix/buyTicketless/:codesr/:idofferta', //:codesr = codice estero esadecimale identificativo del museo
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    canActivate: [ensureCodesrGuard],
    loadChildren: () =>
      import('./Modules/buy-ticketless/buy-ticketless.module').then(
        (m) => m.BuyTicketlessModule
      ),
  },
  {
    path: 'myProfile',
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    loadChildren: () =>
      import('./Modules/user-profile/user-profile.module').then(
        (m) => m.UserProfileModule
      ),
  },
  {
    path: 'myTickets',
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    loadChildren: () =>
      import('./Modules/user-tickets/user-tickets.module').then(
        (m) => m.UserTicketsModule
      ),
  },
  {
    path: 'contacts',
    resolve: {
      navigationState: PostLoginDataRestoreResolver
    },
    loadChildren: () => import('./Modules/contacts/contacts.module').then(
      (m) => m.ContactsModule
    )
  },
  {
    path:'rewards',
    canActivate:[authGuard, rewardsSystemHealtyGuard],
    loadChildren: () => import('./Modules/rewards/rewards.module').then(
      (m) => m.RewardsModule
    )
  },
  {
    path: ':lang/preventivo',
    loadChildren: () => import('./Modules/group-payment/group-payment.module').then(
      (m) => m.GroupPaymentModule
    )
  },
  {
    path: 'itinerary/:id',
    data: { type: E_OFFER_GATEWAY_TYPE.ITINERARY },
    loadChildren: () => import('./Modules/offer-gateway/offer-gateway.module').then(
      (m) => m.OfferGatewayModule
    )
  },
  {
    path: 'exhibition/:id',
    data: { type: E_OFFER_GATEWAY_TYPE.EXHIBITION },
    loadChildren: () => import('./Modules/offer-gateway/offer-gateway.module').then(
      (m) => m.OfferGatewayModule
    )
  },
  {
    path: 'login-required',
    component: LoginRequiredComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,{
      bindToComponentInputs: true,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
